<template>
  <a-layout class="index animated fadeIn">
    <a-card :bordered="false">
      <div class="content">
        <a-form ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :scrollToFirstError="true">
          <SmallSquare class="m-b-20" content="申请信息" />
          <a-form-item ref="submit_name" label="提交人" name="submit_name">
            {{form.submit_name || '-'}}
          </a-form-item>
          <!-- <a-form-item ref="apply_name" label="门店名称" name="apply_name" v-if="$route.query.type=='store'">
            {{form.apply_name}}
          </a-form-item> -->
          <a-form-item ref="apply_name" :label="$route.query.type=='store'?'门店名称':'经销商名称'" name="apply_name">
            {{form.apply_name || '-'}}
          </a-form-item>
          <a-form-item ref="group_task_id" label="提交任务(ID)" name="group_task_id">
            {{form.group_task_id || '-'}}
          </a-form-item>
          <a-form-item ref="create_time" label="提交时间" name="create_time">
            {{form.create_time || '-'}}
          </a-form-item>
          <a-form-item ref="apply_describe_text" label="申请描述" name="apply_describe_text">
            {{form.apply_describe_text || '-'}}
          </a-form-item>
          <a-form-item ref="apply_image_text" label="申请图片" name="apply_image_text">
            <div class="s_flex">
              <a-image v-for="(item,index) in form.apply_image_text" :width="80" :src="info.picdomain+item" :key="index" style="padding-left:10px"/>
            </div>
          </a-form-item>
          <a-form-item ref="code_number" label="申请二维码" name="code_number">
            {{form.code_number || '-'}} <a class="ml15" @click="Lookcode">查看二维码</a>
          </a-form-item>
        </a-form>
        <SmallSquare class="m-b-20" content="审核信息" />
        <a-form :model="form1" :label-col="labelCol" :wrapper-col="wrapperCol" :scrollToFirstError="true" :rules="rules">
          <a-form-item label="处理方式" name="examine_status">
            <a-radio-group v-model:value="form1.examine_status">
              <a-radio :value="1">通过</a-radio>
              <a-radio :value="2">拒绝</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item v-if="form1.examine_status==2" label="拒绝原因" name="refuse_reason" required>
            <a-textarea v-model:value="form1.refuse_reason" style="width:500px" />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
            <a-button @click="$router.go(-1)" class='m-r-10'> 返回 </a-button>
            <a-button type="primary" @click="onSubmit()" v-if="examine_status==0"> 保存 </a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
  </a-layout>
  <a-modal title='' :keyboard="false" v-model:visible="isCode" centered :width='1300' destroyOnClose :footer='null'>
    <codeDetail :id="$route.query.id" />
  </a-modal>
</template>
<script>
import { ref, onMounted, reactive, toRefs, inject } from "vue";
("@ant-design/icons-vue");
import { message } from "ant-design-vue";
import codeDetail from "./codeDetail";
import { detailexamine, taskexamine } from "@/api/guide";
import { iscode } from "@/utils/app";
import store from "@/store";
// 初始化默认筛选项数值
let defForm = {
  examine_status: 1,
  refuse_reason: "",
};
export default {
  components: {
    codeDetail,
  },
  setup() {
    //pass
    const form = ref({});
    const form1 = ref({ ...defForm });

    const state = reactive({
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
      targetId: "",
      isCode: false,
      info: store.state.user.info,
      rules: {
        refuse_reason: [{ required: true, message: "请输入拒绝原因！" }],
      },
      examine_status:0,
    });
    const momentTime = inject("momentTime");
    const $route = inject("$route");
    const $router = inject("$router");
    const _lodash = inject("_lodash");

    // 初始化
    const init = async () => {
      if ($route.query.id) {
        // 获取详情
        detailexamine({ id: $route.query.id }).then((res) => {
          var result = res.data.data;
          form.value = result;
           state.examine_status=result.examine_status;
          form1.value = result;
         
        });
      }
    };
    const Lookcode = () => {
      state.isCode = true;
    };
    const router = inject("$router");
    const onSubmit = async () => {
      let result = await taskexamine({
        id: $route.query.id,
        ...form1.value,
      }).then((res) => res.data);
      if (iscode(result, true)) {
        init();
        // router.go(-1);
      }
    };
    onMounted(() => {
      init();
    });
    return {
      form,
      ...toRefs(state),
      onSubmit,
      Lookcode,
      form1,
    };
  },
};
</script>
<style lang="less">
@import url("@/style/app-warp/app-warp.less");
</style>
